import { useState, useRef, useCallback } from 'react';

const ACCEPTED_TYPES = [
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    'application/vnd.ms-excel',
    'text/csv',
    'application/csv',
    'application/octet-stream',
];

const isValidFile = (f) =>
    ACCEPTED_TYPES.includes(f.type) ||
    /\.(xlsx|xls|csv)$/i.test(f.name);

export const useUpload = () => {
    const [file, setFile] = useState(null);
    const [date, setDate] = useState('');
    const [isDragging, setDragging] = useState(false);
    const fileInputRef = useRef(null);

    const setValidFile = useCallback((f) => {
        if (!f) return;
        if (!isValidFile(f)) {
            alert('Please upload a valid Excel (.xlsx, .xls) or CSV file.');
            return;
        }
        setFile(f);
    }, []);

    const handleFileSelect = useCallback((e) => {
        setValidFile(e.target.files?.[0] ?? null);
        if (fileInputRef.current) fileInputRef.current.value = '';
    }, [setValidFile]);

    const handleDrop = useCallback((e) => {
        e.preventDefault();
        setDragging(false);
        setValidFile(e.dataTransfer.files?.[0] ?? null);
    }, [setValidFile]);

    const handleDragOver = useCallback((e) => {
        e.preventDefault();
        setDragging(true);
    }, []);

    const handleDragLeave = useCallback(() => setDragging(false), []);

    const handleRemoveFile = useCallback(() => {
        setFile(null);
        if (fileInputRef.current) fileInputRef.current.value = '';
    }, []);

    const handleDateChange = useCallback((val) => setDate(val ?? ''), []);

    const openFilePicker = useCallback(() => {
        fileInputRef.current?.click();
    }, []);

    return {
        file,
        date,
        isDragging,
        fileInputRef,
        handleFileSelect,
        handleDrop,
        handleDragOver,
        handleDragLeave,
        handleRemoveFile,
        handleDateChange,
        openFilePicker,
    };
};